export const types = {
  SET_ACCOUNTING_REPORTS: "SET_ACCOUNTING_REPORTS",
  ADD_ACCOUNTING_REPORT: "ADD_ACCOUNTING_REPORT",
  MARK_ACCOUNTED_EARNINGS: "MARK_ACCOUNTED_EARNINGS",
};

export const setAccountingReports = payload => ({
  type: types.SET_ACCOUNTING_REPORTS,
  payload,
});

export const addAccountingReport = payload => ({
  type: types.ADD_ACCOUNTING_REPORT,
  payload,
});

export const markAccountedEarnings = payload => ({
  type: types.MARK_ACCOUNTED_EARNINGS,
  payload,
});
